export { default as forumCategoryPolicy } from "./ForumCategory";
export { default as forumCommentPolicy } from "./ForumComment";
export { default as forumThreadPolicy } from "./forumThread";
export { default as newsPolicy } from "./news";
export { default as PagePolicy } from "./Page";
export { default as PollPolicy } from "./Poll";
export { default as SurveyPolicy } from "./Survey";
export { default as PromotionPolicy } from "./Promotion";
export { default as ResourcePolicy } from "./Resource";
export { default as siteSettingsPolicy } from "./siteSettings";
